import "./_article-content-styles.scss";

import './article-content';
